<template>
  <div class="container__error" v-if="handledError">
    <div class="fas fa-3x mb-3" :class="handledError.icon"></div>
    <h3>
      {{ $t(handledError.title) }}
    </h3>
    <div>
      {{ $t(handledError.message) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorAlert',
  props: {
    handledError: {
      required: true,
    },
  },
}
</script>

<style scoped lang="sass">
.container__error
  display: flex
  -webkit-box-orient: vertical
  -webkit-box-direction: normal
  -ms-flex-direction: column
  flex-direction: column
  -webkit-box-align: center
  -ms-flex-align: center
  align-items: center
  -webkit-box-pack: center
  -ms-flex-pack: center
  justify-content: center
</style>
